export default "__VITE_ASSET__CUJTUc4k__"